// @flow

import React from "react";
import { localize } from "redux-i18n";
import Ajv from "ajv";

import { split } from "@transformers/schema";
import actionCreators from "@modules/service/actionCreator";
import { Button, View } from "@components";
import type { StepProps } from "@components";
import {
  EmailNotificationMainForm,
  EmailNotificationContent as EmailNotificationContentForm,
  EmailNotificationDefaultInstructions,
} from "@modules/service/components";

type OwnProps = $Exact<{
  editing?: boolean,
  schema: Object,
  edited: Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class Step1Content extends React.Component<Props> {
  validate: *;

  componentDidMount() {
    this.validate = new Ajv().compile(this.schema);

    if (this.props.data) {
      this.handleChange(this.props.data);
    }
  }

  get data() {
    return this.props.edited;
  }

  get schema() {
    return split(this.props.schema, [
      "name",
      "isActive",
      "includeEmployeePhoneNumber",
      "includeWorkingHours",
      "includeBradfordScore",
      "includeJobTitle",
      "includeAbsenceId",
      "includeLastThreeAbsences",
      "includeDepartmentParent",
      "includeEmployeeRef",
      "includePosition",
      "startInstruction",
      "updateNotification",
      "closedInstruction",
      "includeAbsenceReason",
      "overdueInstruction",
    ]);
  }

  isValid = (data?: Object) => {
    const trimmedName = data && data.name && data.name.trim();
    return (
      this.validate &&
      this.validate({
        ...data,
        name: trimmedName || null,
      })
    );
  };

  handleSubmit = () => {
    if (this.props.handleSubmit) {
      this.props.handleSubmit(this.data, true);
    }
  };

  handleChange = (formData: Object) => {
    this.props.onChange(
      {
        ...this.data,
        ...formData,
      },
      true,
    );
  };

  render() {
    if (!this.props.editable) {
      return <div />;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex flex-column justify-content-center">
          {this.schema && this.data ? (
            <React.Fragment>
              <View gap={6}>
                <View className="gs-container">
                  <EmailNotificationMainForm
                    data={this.data}
                    schema={this.schema}
                    onChange={this.handleChange}
                    editing={true}
                  />
                </View>
                <View className="gs-container">
                  <EmailNotificationDefaultInstructions
                    data={this.data}
                    schema={this.schema}
                    onChange={this.handleChange}
                    editing={true}
                  />
                </View>
                <View className="gs-container">
                  <EmailNotificationContentForm
                    data={this.data}
                    schema={this.schema}
                    onChange={this.handleChange}
                    editing={true}
                  />
                </View>
              </View>
            </React.Fragment>
          ) : null}
        </div>
        {this.props.editing ? null : (
          <View direction="row" justifyContent="end">
            <Button
              materialIcon="fast_forward"
              onClick={this.handleSubmit}
              disabled={!this.isValid(this.data)}
            >
              {this.props.t("NEXT")}
            </Button>
          </View>
        )}
      </React.Fragment>
    );
  }
}

export default localize()(Step1Content);
